import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AuthService } from '../../auth.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard.service';
import { Channel } from '../signup/signup.component';
import {encrypt} from '../../consts/utilities';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-password-reset-verification',
    templateUrl: './password-reset-verification.component.html',
    styleUrls: ['./password-reset-verification.component.scss']
})
export class PasswordResetVerificationComponent implements OnInit {
    public isMobile: boolean;
    message: string;

    passwordForm = new FormGroup({
        password: new FormControl('', [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(24)
        ]),
        passConfirmation: new FormControl('', [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(24)
        ])
    }, { validators: this.passwordValidator });

    @Input() channel: Channel;
    @Input() user: string;

    @Output() passwordResetted = new EventEmitter<boolean>();

    constructor(
        private authService: AuthService,
        private router: Router,
        private snackBar: MatSnackBar,
        private dashboard: DashboardService
    ) {}

    ngOnInit() {
        this.isMobile = this.dashboard.isMobile;
        this.dashboard.isMobile$.subscribe((value) => {
            this.isMobile = value;
        });
    }

    passwordValidator(form: FormGroup) {
        const condition = form.get('password').value !== form.get('passConfirmation').value;
        return condition ? { passwordDoCheck: true } : null;
    }

    requestPasswordReset(): void {
        const password = this.passwordForm.get('password').value;
        const passwordCf = this.passwordForm.get('passConfirmation').value;

        if (password !== passwordCf) {
            return;
        }

        this.authService.changePassword(this.user, password)
            .subscribe(
                (response) => this.onResetPasswordResponse(response),
                (err) => this.onResetPasswordError(err)
            );
    }

    private onResetPasswordResponse(response: any): void {
        this.passwordResetted.emit(true);
    }

    private onResetPasswordError(error: HttpErrorResponse): void {
        this.passwordResetted.emit(false);
    }
}
